import React from 'react';
import { Interpreter } from 'xstate';
import PropTypes from 'prop-types';
import { useService } from '@xstate/react';
import ProfilePictureFormTemplate from 'view/templates/profile-picture-form';
import SignupLayoutTemplate from 'view/templates/signup-layout';
import LoadingTemplate from 'view/templates/loading';
import LoadingErrorTemplate from 'view/templates/loading-error';
import PAGES from 'routes/pages';
import { FORM_ACTIONS, FORM_STATE } from 'machines/utils/form';
import { isDocumentEditable } from 'shared/utils/documents';
import { DOCUMENT_TYPE } from 'shared/constants/documents';

const ProfilePictureForm = ({ context, history, isDesktop }) => {
  const { services } = context;
  const { ProfilePictureMachine } = services;
  const [current, send] = useService(ProfilePictureMachine);
  const { documents } = current.context;

  const canEditDocument = isDocumentEditable(
    documents,
    DOCUMENT_TYPE.PROFILE_PICTURE
  );
  const goBack = () => history.push(PAGES.DOCUMENT_HUB.path);

  if (current.matches(FORM_STATE.success) || !canEditDocument) {
    goBack();
    return <></>;
  }

  const setPicture = data => {
    send(FORM_ACTIONS.change, {
      name: 'file',
      value: data,
      touched: true
    });
  };

  const clearForm = () => {
    setPicture(null);
  };

  const goToEdit = () => {
    send(FORM_ACTIONS.edit);
  };

  const handleSubmit = () => {
    send(FORM_ACTIONS.submit);
  };

  const retry = () => send(FORM_ACTIONS.retry);

  const defaultPage = () => (
    <ProfilePictureFormTemplate
      goToEdit={goToEdit}
      onClear={clearForm}
      onTakePicture={setPicture}
      onSubmit={handleSubmit}
      context={current.context}
      state={current.toStrings().pop()}
    />
  );

  const page =
    {
      [FORM_STATE.loading]: () => <LoadingTemplate />,
      [FORM_STATE.error]: () => <LoadingErrorTemplate onRetry={retry} />
    }[current.value] || defaultPage;

  return (
    <SignupLayoutTemplate isDesktop={isDesktop} page={page()} onBack={goBack} />
  );
};

ProfilePictureForm.propTypes = {
  context: PropTypes.shape({
    services: PropTypes.shape({
      ProfilePictureMachine: PropTypes.instanceOf(Interpreter)
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }),
  isDesktop: PropTypes.bool
};

ProfilePictureForm.defaultProps = {
  history: {},
  isDesktop: false
};

export default ProfilePictureForm;
